var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.363,
    height: 13.2,
    viewBox: "0 0 11.363 13.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_Paper",
    "data-name": "Iconly/Light/Paper",
    transform: "translate(-3.649 -2.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper",
    transform: "translate(4.25 2.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    d: "M7.6.762H3.256A2.5,2.5,0,0,0,.75,3.2v7A2.5,2.5,0,0,0,3.2,12.754h5.28A2.54,2.54,0,0,0,10.912,10.2V4.209Z",
    transform: "translate(-0.75 -0.754)",
    fill: "none",
    stroke: "#0056ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3",
    d: "M10.975.75v1.9a1.682,1.682,0,0,0,1.678,1.683h1.8",
    transform: "translate(-4.294 -0.75)",
    fill: "none",
    stroke: "#0056ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-5",
    x1: 3.528,
    transform: "translate(3.031 8.238)",
    fill: "none",
    stroke: "#0056ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-7",
    x1: 2.193,
    transform: "translate(3.03 5.787)",
    fill: "none",
    stroke: "#0056ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/Docs.be0d2302eaac46b7e646d03e5d4f2725.svg";
export { ForwardRef as ReactComponent };